var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIcTemplate(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 25,
    viewBox: "0 0 25 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1394_18152)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M20.3125 4.6875V7.8125H4.6875V4.6875H20.3125ZM20.3125 3.125H4.6875C4.2731 3.125 3.87567 3.28962 3.58265 3.58265C3.28962 3.87567 3.125 4.2731 3.125 4.6875V7.8125C3.125 8.2269 3.28962 8.62433 3.58265 8.91735C3.87567 9.21038 4.2731 9.375 4.6875 9.375H20.3125C20.7269 9.375 21.1243 9.21038 21.4174 8.91735C21.7104 8.62433 21.875 8.2269 21.875 7.8125V4.6875C21.875 4.2731 21.7104 3.87567 21.4174 3.58265C21.1243 3.28962 20.7269 3.125 20.3125 3.125Z",
    fill: "#D1F27A"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M7.8125 12.5V20.3125H4.6875V12.5H7.8125ZM7.8125 10.9375H4.6875C4.2731 10.9375 3.87567 11.1021 3.58265 11.3951C3.28962 11.6882 3.125 12.0856 3.125 12.5V20.3125C3.125 20.7269 3.28962 21.1243 3.58265 21.4174C3.87567 21.7104 4.2731 21.875 4.6875 21.875H7.8125C8.2269 21.875 8.62433 21.7104 8.91735 21.4174C9.21038 21.1243 9.375 20.7269 9.375 20.3125V12.5C9.375 12.0856 9.21038 11.6882 8.91735 11.3951C8.62433 11.1021 8.2269 10.9375 7.8125 10.9375Z",
    fill: "#D1F27A"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M20.3125 12.5V20.3125H12.5V12.5H20.3125ZM20.3125 10.9375H12.5C12.0856 10.9375 11.6882 11.1021 11.3951 11.3951C11.1021 11.6882 10.9375 12.0856 10.9375 12.5V20.3125C10.9375 20.7269 11.1021 21.1243 11.3951 21.4174C11.6882 21.7104 12.0856 21.875 12.5 21.875H20.3125C20.7269 21.875 21.1243 21.7104 21.4174 21.4174C21.7104 21.1243 21.875 20.7269 21.875 20.3125V12.5C21.875 12.0856 21.7104 11.6882 21.4174 11.3951C21.1243 11.1021 20.7269 10.9375 20.3125 10.9375Z",
    fill: "#D1F27A"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1394_18152"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 25,
    height: 25,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcTemplate);
export default __webpack_public_path__ + "static/media/ic_template.4fe5d6e79aa875bce3441076ae8d49a3.svg";
export { ForwardRef as ReactComponent };